import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Shield2 = function Shield2(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#3417AA' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor,
    _ref$circleColor = _ref.circleColor,
    circleColor = _ref$circleColor === void 0 ? '' : _ref$circleColor;
  var color = !ignoreColor ? colorProp : undefined;
  if (circleColor) {
    return /*#__PURE__*/_jsxs("svg", {
      className: className,
      width: size,
      height: size * 1.04444444444,
      viewBox: "0 0 47 45",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [/*#__PURE__*/_jsx("rect", {
        width: "46.4211",
        height: "45",
        rx: "22.5",
        fill: circleColor
      }), /*#__PURE__*/_jsx("path", {
        d: "M35.3984 15.4561C35.3984 14.6867 35.3618 13.9172 35.3618 13.2211C35.3618 12.6715 34.9221 12.1952 34.3359 12.1952C30.0124 12.1952 26.6783 10.9495 23.9303 8.27479C23.5273 7.9084 22.9044 7.9084 22.5014 8.27479C19.7534 10.9495 16.4559 12.1952 12.0958 12.1952C11.5462 12.1952 11.0699 12.6349 11.0699 13.2211C11.0699 13.9172 11.0699 14.6867 11.0333 15.4561C10.8867 22.7473 10.7035 32.7132 22.8311 36.9267C22.941 36.9634 23.051 37 23.1609 37C23.2708 37 23.3807 37 23.4906 36.9267C35.6915 32.7132 35.5083 22.7473 35.3984 15.4561ZM28.1438 20.4024L22.538 26.0082C22.3548 26.1914 22.0983 26.3013 21.8052 26.3013C21.5487 26.3013 21.2923 26.1914 21.0724 26.0082L18.2879 23.2236C17.8848 22.8206 17.8848 22.1977 18.2879 21.7947C18.6909 21.3917 19.3138 21.3917 19.7168 21.7947L21.8052 23.8831L26.7149 18.9735C27.1179 18.5704 27.7408 18.5704 28.1438 18.9735C28.5469 19.3765 28.5469 19.9994 28.1438 20.4024Z",
        fill: color
      })]
    });
  }
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size * 1.16,
    viewBox: "0 0 25 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      d: "M24.3984 7.4561C24.3984 6.68667 24.3618 5.91725 24.3618 5.2211C24.3618 4.67151 23.9221 4.1952 23.3359 4.1952C19.0124 4.1952 15.6783 2.94946 12.9303 0.274795C12.5273 -0.0915982 11.9044 -0.0915982 11.5014 0.274795C8.75343 2.94946 5.45589 4.1952 1.09581 4.1952C0.546225 4.1952 0.0699135 4.63487 0.0699135 5.2211C0.0699135 5.91725 0.069914 6.68667 0.0332747 7.4561C-0.113282 14.7473 -0.296478 24.7132 11.8311 28.9267C11.941 28.9634 12.051 29 12.1609 29C12.2708 29 12.3807 29 12.4906 28.9267C24.6915 24.7132 24.5083 14.7473 24.3984 7.4561ZM17.1438 12.4024L11.538 18.0082C11.3548 18.1914 11.0983 18.3013 10.8052 18.3013C10.5487 18.3013 10.2923 18.1914 10.0724 18.0082L7.28785 15.2236C6.88482 14.8206 6.88482 14.1977 7.28785 13.7947C7.69089 13.3917 8.31376 13.3917 8.71679 13.7947L10.8052 15.8831L15.7149 10.9735C16.1179 10.5704 16.7408 10.5704 17.1438 10.9735C17.5469 11.3765 17.5469 11.9994 17.1438 12.4024Z",
      fill: color
    })
  });
};
export default Shield2;